import '../stylesheets/homepage.css'
import '../stylesheets/digibord.css'
import '../stylesheets/print_examples_framed.css'

// --- Plausible analytics helper ---
function trackEvent(event, props) {
  if (typeof plausible !== 'undefined') plausible(event, { props: props });
}
var tracked = {};
function trackOnce(event, props) {
  if (tracked[event]) return;
  tracked[event] = true;
  trackEvent(event, props);
}

// --- Scroll to information request on validation error ---
document.addEventListener('DOMContentLoaded', function() {
  var errorTarget = document.getElementById('informatiepresentatie');
  if (errorTarget && errorTarget.dataset.scrollOnError === 'true') {
    errorTarget.scrollIntoView();
  }
});

// --- Active section highlighting ---
document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('.section-link');
  var sections = [];

  links.forEach(function(link) {
    var id = link.getAttribute('href').slice(1);
    var section = document.getElementById(id);
    if (section) sections.push({ el: section, link: link, id: id });
  });

  function setActive() {
    var scrollPos = window.scrollY + 160;
    var current = sections[0];

    sections.forEach(function(s) {
      if (s.el.offsetTop <= scrollPos) current = s;
    });

    links.forEach(function(l) {
      l.classList.remove('bg-brand/10', 'text-brand', 'dark:bg-brand/20', 'dark:text-brand-300');
    });

    if (current) {
      current.link.classList.add('bg-brand/10', 'text-brand', 'dark:bg-brand/20', 'dark:text-brand-300');
    }
  }

  window.addEventListener('scroll', setActive, { passive: true });
  setActive();

  // Track section nav clicks
  links.forEach(function(link) {
    link.addEventListener('click', function() {
      var section = link.getAttribute('href').slice(1);
      trackEvent('Section Nav Click', { section: section });
    });
  });
});

// --- Hero slideshow ---
document.addEventListener('DOMContentLoaded', function() {
  var container = document.querySelector('[data-hero-slideshow]');
  if (!container) return;
  var slides = container.querySelectorAll('.hero-slide');
  if (slides.length < 2) return;
  var current = 0;

  setInterval(function() {
    slides[current].classList.add('opacity-0');
    current = (current + 1) % slides.length;
    slides[current].classList.remove('opacity-0');
    trackOnce('Hero Slide View', { slide: String(current) });
  }, 5000);
});

// --- Laptop lid close on scroll ---
document.addEventListener('DOMContentLoaded', function() {
  var lid = document.querySelector('[data-laptop-lid]');
  var kbDeck = document.querySelector('[data-keyboard-deck]');
  var kbContent = document.querySelector('[data-keyboard-content]');
  var closedLaptop = document.querySelector('[data-laptop-closed]');
  if (!lid) return;
  var ticking = false;
  var isClosed = false;

  // Threshold: how many px before the lid top hits the viewport top the animation starts.
  // On mobile the laptop sits below the text, so start much earlier and close faster.
  var isMobile = window.innerWidth < 1024;
  var threshold = isMobile ? 115 : 30;
  // Scroll distance over which the lid fully closes (px)
  var closeDistance = isMobile ? 220 : 290;

  var startClose = 0;
  var fullClose = 0;

  function recalc() {
    isMobile = window.innerWidth < 1024;
    threshold = isMobile ? 115 : 30;
    closeDistance = isMobile ? 220 : 290;
    var lidTop = lid.getBoundingClientRect().top + window.scrollY;
    startClose = lidTop - threshold;
    fullClose = startClose + closeDistance;
  }

  // Position closed laptop overlay to match keyboard deck position
  if (closedLaptop && kbDeck) {
    closedLaptop.style.top = kbDeck.offsetTop + 'px';
  }

  recalc();
  window.addEventListener('resize', function() {
    recalc();
    if (closedLaptop && kbDeck) {
      closedLaptop.style.top = kbDeck.offsetTop + 'px';
    }
  });

  // Max angle: just past -90 so back face is barely visible (closed laptop look)
  var maxAngle = -97;
  // Keyboard fades out in the last 40% of the animation
  var kbFadeStart = 0.6;

  function showClosed() {
    if (!isClosed) {
      isClosed = true;
      trackOnce('Laptop Lid Close');
      lid.style.visibility = 'hidden';
      if (kbDeck) kbDeck.style.visibility = 'hidden';
      if (closedLaptop) {
        closedLaptop.style.opacity = '1';
        closedLaptop.style.pointerEvents = '';
      }
    }
  }

  function showOpen() {
    if (isClosed) {
      isClosed = false;
      lid.style.visibility = '';
      if (kbDeck) kbDeck.style.visibility = '';
      if (closedLaptop) {
        closedLaptop.style.opacity = '0';
        closedLaptop.style.pointerEvents = 'none';
      }
    }
  }

  function update() {
    ticking = false;
    var y = window.scrollY;
    if (y <= startClose) {
      showOpen();
      lid.style.transform = '';
      if (kbContent) kbContent.style.opacity = '';
    } else if (y >= fullClose) {
      showClosed();
    } else {
      showOpen();
      var p = (y - startClose) / (fullClose - startClose);
      var tz = p * 20;
      lid.style.transform = 'translateZ(' + tz + 'px) rotateX(' + (p * maxAngle) + 'deg)';
      if (kbContent) {
        var kbOpacity = p < kbFadeStart ? 1 : 1 - (p - kbFadeStart) / (1 - kbFadeStart);
        kbContent.style.opacity = kbOpacity;
      }
    }
  }

  // Auto-complete: if scroll pauses in the danger zone, finish the animation
  var snapTimer = null;
  var snapThreshold = 0.85;
  var snapDelay = 400;

  function autoSnap() {
    var y = window.scrollY;
    var p = (y - startClose) / (fullClose - startClose);
    if (p >= snapThreshold && p < 1) {
      window.scrollTo({ top: fullClose, behavior: 'smooth' });
    }
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
    clearTimeout(snapTimer);
    snapTimer = setTimeout(autoSnap, snapDelay);
  }, { passive: true });
});

// --- Print examples slideshow & draggable paintings ---
document.addEventListener('DOMContentLoaded', function() {
  var trigger = document.getElementById('slideshow-trigger');
  var triggerWrapper = document.getElementById('slideshow-trigger-wrapper');
  var featuredPrints = document.getElementById('featured-prints');
  var slideshow = document.getElementById('print-slideshow');
  var track = document.getElementById('slideshow-track');
  if (!trigger || !slideshow || !track || !featuredPrints) return;

  var position = 0;
  var speed = 0.4;
  var paused = false;
  var dragPaused = false;
  var running = false;
  var setWidth = 0;
  var isDesktop = window.matchMedia('(min-width: 768px)');

  function computeSetWidth() {
    setWidth = track.scrollWidth / 2;
  }

  function animate() {
    if (!running) return;
    if (!paused && !dragPaused) {
      position -= speed;
      if (Math.abs(position) >= setWidth) {
        position += setWidth;
      }
      track.style.transform = 'translateX(' + position + 'px)';
    }
    requestAnimationFrame(animate);
  }

  // On mobile, hide the duplicated items (second half of track) since we use native scroll
  function setupMobile() {
    var items = track.children;
    var half = items.length / 2;
    for (var i = half; i < items.length; i++) {
      items[i].style.display = 'none';
    }
    track.style.transform = '';
  }

  function setupDesktop() {
    var items = track.children;
    for (var i = 0; i < items.length; i++) {
      items[i].style.display = '';
    }
    computeSetWidth();
    if (!running) {
      running = true;
      animate();
    }
  }

  // Mobile: slideshow is already visible, just hide duplicated items
  if (!isDesktop.matches) {
    setupMobile();
  }

  // Desktop: button triggers the slideshow
  trigger.addEventListener('click', function() {
    trackEvent('Print Slideshow Open');
    featuredPrints.style.opacity = '0';
    featuredPrints.style.pointerEvents = 'none';
    triggerWrapper.style.opacity = '0';
    triggerWrapper.style.pointerEvents = 'none';

    setTimeout(function() {
      featuredPrints.style.display = 'none';
      triggerWrapper.style.display = 'none';
      slideshow.classList.remove('slideshow-desktop-hidden');
      slideshow.classList.add('slideshow-entering');
      setupDesktop();
      initDraggablePaintings();
    }, 400);
  });

  // Pause on hover (desktop only)
  slideshow.addEventListener('mouseenter', function() { paused = true; });
  slideshow.addEventListener('mouseleave', function() { paused = false; });

  // Navigation (desktop only) - smooth animated scrolling with seamless looping
  var navAnimating = false;
  var navTarget = 0;

  // Normalize position into (-setWidth, 0] range
  function normalizePosition(pos) {
    pos = pos % setWidth;
    if (pos > 0) pos -= setWidth;
    return pos;
  }

  function smoothNavTo(target) {
    navTarget = target;
    if (navAnimating) return;
    navAnimating = true;
    paused = true;
    var start = position;
    var startTime = performance.now();
    var duration = 400;

    function step(now) {
      var t = Math.min((now - startTime) / duration, 1);
      // ease-out cubic
      t = 1 - Math.pow(1 - t, 3);
      position = start + (navTarget - start) * t;
      track.style.transform = 'translateX(' + position + 'px)';
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        // Normalize after animation so we stay in the main copy range
        position = normalizePosition(navTarget);
        track.style.transform = 'translateX(' + position + 'px)';
        navAnimating = false;
        paused = slideshow.matches(':hover');
      }
    }
    requestAnimationFrame(step);
  }

  document.getElementById('slideshow-prev').addEventListener('click', function(e) {
    e.stopPropagation();
    trackEvent('Print Slideshow Navigate', { direction: 'prev' });
    var current = navAnimating ? navTarget : position;
    smoothNavTo(current + 300);
  });

  document.getElementById('slideshow-next').addEventListener('click', function(e) {
    e.stopPropagation();
    trackEvent('Print Slideshow Navigate', { direction: 'next' });
    var current = navAnimating ? navTarget : position;
    smoothNavTo(current - 300);
  });

  // Close button - return to featured prints view
  document.getElementById('slideshow-close').addEventListener('click', function() {
    trackEvent('Print Slideshow Close');
    running = false;
    slideshow.classList.add('slideshow-desktop-hidden');
    slideshow.classList.remove('slideshow-entering');
    position = 0;
    track.style.transform = '';

    featuredPrints.style.display = '';
    triggerWrapper.style.display = '';
    // Force reflow before removing opacity
    void featuredPrints.offsetHeight;
    featuredPrints.style.opacity = '';
    featuredPrints.style.pointerEvents = '';
    triggerWrapper.style.opacity = '';
    triggerWrapper.style.pointerEvents = '';
  });

  // Handle resize between mobile/desktop
  isDesktop.addEventListener('change', function() {
    if (isDesktop.matches && !slideshow.classList.contains('slideshow-desktop-hidden')) {
      setupDesktop();
    } else if (!isDesktop.matches) {
      running = false;
      setupMobile();
    }
  });

  // === Draggable paintings Easter egg (desktop only) ===
  if (isDesktop.matches) {
    initDraggablePaintings();
  }
  isDesktop.addEventListener('change', function() {
    if (isDesktop.matches) initDraggablePaintings();
  });

  function spawnBeetle(frameEl) {
    var rect = frameEl.getBoundingClientRect();
    var beetle = document.createElement('span');
    beetle.className = 'wall-beetle wall-beetle-legs';
    beetle.textContent = '\uD83E\uDEB3';
    document.body.appendChild(beetle);

    var startX = rect.left + rect.width / 2;
    var startY = rect.top + rect.height / 2;

    var distLeft = startX, distRight = window.innerWidth - startX;
    var distTop = startY, distBottom = window.innerHeight - startY;
    var minDist = Math.min(distLeft, distRight, distTop, distBottom);
    var targetX, targetY;
    if (minDist === distLeft) { targetX = -30; targetY = startY + (Math.random() - 0.5) * 200; }
    else if (minDist === distRight) { targetX = window.innerWidth + 30; targetY = startY + (Math.random() - 0.5) * 200; }
    else if (minDist === distTop) { targetX = startX + (Math.random() - 0.5) * 200; targetY = -30; }
    else { targetX = startX + (Math.random() - 0.5) * 200; targetY = window.innerHeight + 30; }

    var totalDx = targetX - startX, totalDy = targetY - startY;
    var totalDist = Math.sqrt(totalDx * totalDx + totalDy * totalDy);
    var duration = totalDist / (2.45 + Math.random() * 1.05);
    var step = 0;
    var steps = Math.ceil(duration);

    var perpX = -totalDy / totalDist, perpY = totalDx / totalDist;
    var wobbleAmp = 15 + Math.random() * 15;
    var wobbleFreq = 3 + Math.random() * 2;

    var baseAngle = Math.atan2(totalDy, totalDx) * (180 / Math.PI) + 90;

    beetle.style.left = startX + 'px';
    beetle.style.top = startY + 'px';
    beetle.style.transform = 'rotate(' + baseAngle + 'deg)';

    function moveBeetle() {
      step++;
      var progress = step / steps;
      var wobble = Math.sin(progress * wobbleFreq * Math.PI * 2) * wobbleAmp * (1 - progress);
      var x = startX + totalDx * progress + perpX * wobble;
      var y = startY + totalDy * progress + perpY * wobble;
      beetle.style.left = x + 'px';
      beetle.style.top = y + 'px';

      if (step < steps) {
        requestAnimationFrame(moveBeetle);
      } else {
        beetle.remove();
      }
    }

    requestAnimationFrame(moveBeetle);
  }

  var firstDragDone = false;
  var dragZIndex = 100;

  function initDraggablePaintings() {
    var paintings = document.querySelectorAll('[data-draggable-painting]');
    paintings.forEach(function(frame) {
      if (frame._dragInit) return;
      frame._dragInit = true;

      var startX, startY, currentX, currentY, isDragging = false;
      var wrapper = frame.closest('.framed-print-wrapper') || frame.closest('.slideshow-item');
      var stain = wrapper ? wrapper.querySelector('.wall-stain') : null;
      var nail = wrapper ? wrapper.querySelector('.wall-nail') : null;
      var overflowEls = [];
      var dragThreshold = 6;
      var didDrag = false;

      var el = frame.parentElement;
      while (el) {
        var style = getComputedStyle(el);
        if (style.overflow === 'hidden' || style.overflowX === 'hidden' || style.overflowY === 'hidden') {
          overflowEls.push(el);
        }
        el = el.parentElement;
      }

      frame.addEventListener('mousedown', function(e) {
        if (e.button !== 0) return;
        startX = e.clientX;
        startY = e.clientY;
        currentX = 0;
        currentY = 0;
        didDrag = false;

        frame.classList.remove('is-swinging');
        frame.style.transform = '';

        var onMove = function(e) {
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;

          if (!isDragging && (Math.abs(dx) > dragThreshold || Math.abs(dy) > dragThreshold)) {
            isDragging = true;
            didDrag = true;
            document.querySelectorAll('[data-draggable-painting].is-swinging').forEach(function(el) {
              el.style.zIndex = dragZIndex;
            });
            dragZIndex += 2;
            frame.classList.add('is-dragging');
            frame.style.zIndex = dragZIndex;
            frame.style.transition = 'none';
            if (stain) {
              stain.style.width = frame.offsetWidth + 'px';
              stain.style.height = frame.offsetHeight + 'px';
              stain.style.left = frame.offsetLeft + 'px';
              stain.style.top = frame.offsetTop + 'px';
              stain.classList.remove('is-fading');
              stain.classList.add('is-visible');
            }
            if (nail) {
              nail.classList.remove('is-fading');
              nail.classList.add('is-visible');
            }
            overflowEls.forEach(function(el) { el.style.overflow = 'visible'; });
            document.documentElement.style.overflowX = 'hidden';
            dragPaused = true;
            var plaque = wrapper ? wrapper.querySelector('.museum-plaque-title') : null;
            trackEvent('Painting Drag', { title: plaque ? plaque.textContent.trim() : 'unknown' });
            if (!firstDragDone || Math.random() < 0.28) {
              firstDragDone = true;
              spawnBeetle(frame);
            }
          }

          if (isDragging) {
            e.preventDefault();
            currentX = dx;
            currentY = dy;
            var rot = dx * 0.04;
            rot = Math.max(-15, Math.min(15, rot));
            frame.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) rotate(' + rot + 'deg)';
          }
        };

        var onUp = function() {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);

          if (isDragging) {
            isDragging = false;
            frame.classList.remove('is-dragging');

            var rot = currentX * 0.04;
            rot = Math.max(-15, Math.min(15, rot));
            frame.style.setProperty('--drag-x', currentX + 'px');
            frame.style.setProperty('--drag-y', currentY + 'px');
            frame.style.setProperty('--drag-rot', rot + 'deg');
            frame.style.transform = '';
            frame.style.transition = '';

            frame.classList.add('is-swinging');

            if (stain) {
              stain.classList.remove('is-visible');
              stain.classList.add('is-fading');
            }
            if (nail) {
              nail.classList.remove('is-visible');
              nail.classList.add('is-fading');
            }

            frame.addEventListener('animationend', function onEnd() {
              frame.removeEventListener('animationend', onEnd);
              frame.classList.remove('is-swinging');
              frame.style.transform = '';
              frame.style.zIndex = '';
              overflowEls.forEach(function(el) { el.style.overflow = ''; });
              document.documentElement.style.overflowX = '';
              dragPaused = false;
            });
          }
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
      });

      // Prevent click (lightbox) after dragging
      frame.addEventListener('click', function(e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
          didDrag = false;
        }
      }, true);
    });
  }
});

// --- Digibord carousel, drawing pens, and CRT power ---
(function() {
  // --- Carrousel ---
  var current = 0, total = 5;
  var titles = [];
  var figures = document.querySelectorAll('#digibord-carousel-track figure[data-title]');
  for (var i = 0; i < figures.length; i++) { titles.push(figures[i].getAttribute('data-title')); }
  function update() {
    var track = document.getElementById('digibord-carousel-track');
    var dotsEl = document.getElementById('digibord-carousel-dots');
    var titleEl = document.getElementById('digibord-carousel-title');
    if (!track || !dotsEl) return;
    var dots = dotsEl.children;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    for (var i = 0; i < dots.length; i++) {
      dots[i].className = 'rounded-full transition sm:h-2.5 sm:w-2.5 h-2 w-2 cursor-pointer ' + (i === current ? 'bg-white' : 'bg-white/30');
    }
    if (titleEl && titles[current]) { titleEl.textContent = titles[current]; }
  }
  // --- Autoplay ---
  var autoplayDelay = 5000;
  var autoplayTimer = null;
  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(function() {
      current = (current + 1) % total;
      update();
    }, autoplayDelay);
  }
  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
  }
  startAutoplay();

  window.digibordCarousel = function(dir) {
    current = (current + dir + total) % total;
    update();
    startAutoplay();
    trackEvent('Digibord Slide Change', { direction: dir > 0 ? 'next' : 'prev', slide: String(current) });
  };
  window.digibordCarouselTo = function(i) {
    current = i;
    update();
    startAutoplay();
    trackEvent('Digibord Slide Change', { direction: 'dot', slide: String(current) });
  };

  // --- Tekenstift ---
  var canvas = document.getElementById('digibord-canvas');
  var screen = document.getElementById('digibord-carousel');
  var pens = document.getElementById('digibord-pens');
  if (!canvas || !screen || !pens) return;
  var ctx = canvas.getContext('2d');
  var penColor = null;
  var drawing = false;
  var autoActivate = true;

  var PAD = 80;
  function resizeCanvas() {
    canvas.width = screen.offsetWidth + PAD * 2;
    canvas.height = screen.offsetHeight + PAD * 2;
  }

  function activatePen(color) {
    penColor = color;
    canvas.classList.remove('pointer-events-none');
    canvas.style.cursor = 'none';
    resizeCanvas();
    redraw();
    var btns = pens.querySelectorAll('[data-pen-color]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-pen-color') === color) {
        btns[i].classList.add('active');
      } else {
        btns[i].classList.remove('active');
      }
    }
  }

  function deactivatePen() {
    penColor = null;
    drawing = false;
    canvas.classList.add('pointer-events-none');
    canvas.style.cursor = '';
    var btns = pens.querySelectorAll('[data-pen-color]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('active');
    }
    cursorX = -100; cursorY = -100;
    redraw();
  }

  // Stift-knoppen
  pens.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pen-color]');
    if (!btn) return;
    var color = btn.getAttribute('data-pen-color');
    if (penColor === color) {
      deactivatePen();
    } else {
      trackEvent('Digibord Pen Select', { color: color });
      activatePen(color);
    }
  });

  // Auto-activeer blauwe stift bij hover over het scherm
  var screenWrap = document.getElementById('digibord-screen-wrap');
  var screenOn = true;
  screen.addEventListener('mouseenter', function() {
    if (!penColor && screenOn && autoActivate) {
      trackOnce('Digibord Auto Pen');
      activatePen('#3b82f6');
    }
  });

  // Klik buiten het scherm en de stiften heft de tekenmodus op
  document.addEventListener('mousedown', function(e) {
    if (!penColor) return;
    if (screenWrap.contains(e.target) || pens.contains(e.target)) return;
    autoActivate = false;
    deactivatePen();
  });
  document.addEventListener('touchstart', function(e) {
    if (!penColor) return;
    if (screenWrap.contains(e.target) || pens.contains(e.target)) return;
    deactivatePen();
  }, { passive: true });

  // Custom cursor (stift-SVG) tekenen op canvas
  var cursorX = -100, cursorY = -100;

  function drawCursor() {
    if (!penColor) return;
    var isEraser = penColor === 'eraser';
    ctx.save();
    if (isEraser) {
      ctx.beginPath();
      ctx.arc(cursorX, cursorY, 12, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(255,255,255,0.7)';
      ctx.lineWidth = 2;
      ctx.stroke();
    } else {
      ctx.translate(cursorX, cursorY);
      ctx.rotate(-0.5);
      ctx.scale(4, 4);
      ctx.fillStyle = penColor;
      ctx.beginPath();
      ctx.moveTo(-2, -20);
      ctx.lineTo(2, -20);
      ctx.lineTo(1, -4);
      ctx.lineTo(-1, -4);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgba(0,0,0,0.6)';
      ctx.beginPath();
      ctx.moveTo(-1, -4);
      ctx.lineTo(1, -4);
      ctx.lineTo(0, 0);
      ctx.closePath();
      ctx.fill();
      ctx.fillStyle = 'rgba(255,255,255,0.3)';
      ctx.fillRect(-1.5, -18, 3, 6);
    }
    ctx.restore();
  }

  // Redraw: bewaar paden en cursor
  var paths = [];
  var currentPath = null;

  function drawPath(path) {
    if (path.eraser) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineWidth = 24;
    } else {
      ctx.globalCompositeOperation = 'source-over';
      ctx.strokeStyle = path.color;
      ctx.lineWidth = 3;
    }
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.beginPath();
    if (path.points.length > 0) {
      ctx.moveTo(path.points[0].x, path.points[0].y);
      for (var j = 1; j < path.points.length; j++) {
        ctx.lineTo(path.points[j].x, path.points[j].y);
      }
      ctx.stroke();
    }
  }

  function redraw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var p = 0; p < paths.length; p++) { drawPath(paths[p]); }
    if (currentPath) { drawPath(currentPath); }
    ctx.globalCompositeOperation = 'source-over';
    drawCursor();
  }

  function canvasCoords(e) {
    var rect = screen.getBoundingClientRect();
    return { x: e.clientX - rect.left + PAD, y: e.clientY - rect.top + PAD };
  }

  function isInsideScreen(e) {
    var rect = screen.getBoundingClientRect();
    return e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
  }

  canvas.addEventListener('mousemove', function(e) {
    var c = canvasCoords(e);
    var inside = isInsideScreen(e);
    cursorX = inside ? c.x : -100;
    cursorY = inside ? c.y : -100;
    canvas.style.cursor = inside ? 'none' : '';
    if (drawing && currentPath && inside) {
      currentPath.points.push({ x: c.x, y: c.y });
    }
    redraw();
  });

  canvas.addEventListener('mouseleave', function() {
    cursorX = -100;
    cursorY = -100;
    drawing = false;
    if (currentPath) { paths.push(currentPath); currentPath = null; }
    redraw();
  });

  canvas.addEventListener('mousedown', function(e) {
    if (!penColor) return;
    e.preventDefault();
    stopAutoplay();
    drawing = true;
    trackOnce('Digibord Draw', { color: penColor === 'eraser' ? 'eraser' : penColor });
    var c = canvasCoords(e);
    currentPath = { color: penColor, eraser: penColor === 'eraser', points: [{ x: c.x, y: c.y }] };
  });

  canvas.addEventListener('mouseup', function() {
    drawing = false;
    if (currentPath) { paths.push(currentPath); currentPath = null; }
  });

  // Touch support
  canvas.addEventListener('touchstart', function(e) {
    if (!penColor) return;
    var rect = screen.getBoundingClientRect();
    var tx = e.touches[0].clientX, ty = e.touches[0].clientY;
    if (tx < rect.left || tx > rect.right || ty < rect.top || ty > rect.bottom) {
      deactivatePen();
      return;
    }
    e.preventDefault();
    stopAutoplay();
    trackOnce('Digibord Draw', { color: penColor === 'eraser' ? 'eraser' : penColor });
    cursorX = tx - rect.left + PAD;
    cursorY = ty - rect.top + PAD;
    drawing = true;
    currentPath = { color: penColor, eraser: penColor === 'eraser', points: [{ x: cursorX, y: cursorY }] };
  }, { passive: false });

  canvas.addEventListener('touchmove', function(e) {
    if (!drawing) return;
    e.preventDefault();
    var rect = screen.getBoundingClientRect();
    var tx = e.touches[0].clientX, ty = e.touches[0].clientY;
    var inside = tx >= rect.left && tx <= rect.right && ty >= rect.top && ty <= rect.bottom;
    cursorX = tx - rect.left + PAD;
    cursorY = ty - rect.top + PAD;
    if (currentPath && inside) { currentPath.points.push({ x: cursorX, y: cursorY }); }
    redraw();
  }, { passive: false });

  canvas.addEventListener('touchend', function() {
    drawing = false;
    if (currentPath) { paths.push(currentPath); currentPath = null; }
    cursorX = -100; cursorY = -100;
    redraw();
  });

  // Wis tekening bij slide-wissel, zet scherm aan als het uit staat
  var origCarousel = window.digibordCarousel;
  window.digibordCarousel = function(dir) {
    paths = []; currentPath = null;
    resizeCanvas();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    origCarousel(dir);
    if (!screenOn) powerOn();
  };
  var origCarouselTo = window.digibordCarouselTo;
  window.digibordCarouselTo = function(i) {
    paths = []; currentPath = null;
    resizeCanvas();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    origCarouselTo(i);
    if (!screenOn) powerOn();
  };

  // Resize handler
  window.addEventListener('resize', function() {
    if (penColor) resizeCanvas();
  });

  // --- CRT power aan/uit ---
  var powerBtn = document.getElementById('digibord-power');
  var crt = document.getElementById('digibord-crt');
  var animating = false;

  function powerOff() {
    if (animating || !screenOn) return;
    animating = true;
    if (penColor) deactivatePen();
    crt.style.display = 'block';
    crt.style.animation = 'crt-off 0.5s ease-in forwards';
    powerBtn.className = 'h-3 w-3 cursor-pointer rounded-full transition-colors sm:h-3.5 sm:w-3.5';
    powerBtn.style.background = '#7f1d1d';
    powerBtn.style.boxShadow = '0 0 3px 1px rgba(127,29,29,0.3)';
    powerBtn.style.cursor = 'pointer';
    crt.addEventListener('animationend', function handler() {
      crt.removeEventListener('animationend', handler);
      screen.classList.add('off');
      crt.style.display = 'none';
      crt.style.animation = '';
      screenOn = false;
      animating = false;
    });
  }

  function powerOn() {
    if (animating || screenOn) return;
    animating = true;
    screen.classList.remove('off');
    crt.style.display = 'block';
    crt.style.animation = 'crt-on 0.8s ease-out forwards';
    powerBtn.className = 'h-3 w-3 cursor-pointer rounded-full transition-colors sm:h-3.5 sm:w-3.5';
    powerBtn.style.background = 'radial-gradient(circle at 35% 35%, #86efac, #22c55e 50%, #16a34a)';
    powerBtn.style.boxShadow = '0 0 4px 1px rgba(74,222,128,0.5), 0 0 12px 3px rgba(74,222,128,0.3), 0 0 24px 6px rgba(74,222,128,0.15)';
    crt.addEventListener('animationend', function handler() {
      crt.removeEventListener('animationend', handler);
      crt.style.display = 'none';
      crt.style.animation = '';
      screenOn = true;
      animating = false;
    });
  }

  powerBtn.addEventListener('click', function() {
    trackEvent('Digibord Power Toggle', { state: screenOn ? 'off' : 'on' });
    if (screenOn) { powerOff(); } else { powerOn(); }
  });
})();
